import { Component, Input, Output, EventEmitter, ChangeDetectorRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface AssetHeaderConfig {
  breadcrumbs?: { label: string; route?: string }[];
  title: string;
  description: string;
  /** When set (e.g. discussion header), shown as "Created at {date}" with smaller font */
  createdAt?: string;
  iconPath?: string; // Path to decorative icons (e.g., leaf icons)
  assetId?: string; // Asset ID to copy
}

@Component({
  selector: 'app-asset-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './asset-header.component.html',
  styleUrl: './asset-header.component.scss',
})
export class AssetHeaderComponent {
  private cdr = inject(ChangeDetectorRef);
  @Input() config!: AssetHeaderConfig;
  @Input() isLoggedIn: boolean = false;
  @Input() isBookmarked: boolean = false;
  @Input() isLiked: boolean = false;
  @Input() isPinned: boolean = false;
  @Input() showActions: boolean = false; // Controls visibility of Bookmark/Like/Pin buttons (only for detail pages)
  @Input() showLikeButton: boolean = true; // When false, hide Like button (e.g. challenge and discussion pages)
  @Input() showPinButton: boolean = false; // Pin icon only for discussions
  @Input() showVoteButtons: boolean = false; // Upvote/downvote icons only for discussion detail page
  @Input() userVote: 'up' | 'down' | null = null; // Current user vote state (discussion only)
  @Input() voteCount: number = 0; // Display vote count (discussion only)
  
  @Output() bookmarkClick = new EventEmitter<void>();
  @Output() likeClick = new EventEmitter<void>();
  @Output() pinClick = new EventEmitter<void>();
  @Output() upvoteClick = new EventEmitter<void>();
  @Output() downvoteClick = new EventEmitter<void>();
  
  copySuccess: boolean = false;

  copyAssetId(): void {
    if (this.config.assetId) {
      navigator.clipboard.writeText(this.config.assetId).then(() => {
        this.copySuccess = true;
        this.cdr.detectChanges();
        setTimeout(() => {
          this.copySuccess = false;
          this.cdr.detectChanges();
        }, 2000);
      }).catch(err => {
        console.error('Failed to copy asset ID:', err);
      });
    }
  }

  onBookmarkClick(): void {
    this.bookmarkClick.emit();
  }

  onLikeClick(): void {
    this.likeClick.emit();
  }

  onPinClick(): void {
    this.pinClick.emit();
  }

  onUpvoteClick(): void {
    this.upvoteClick.emit();
  }

  onDownvoteClick(): void {
    this.downvoteClick.emit();
  }
}

